var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.icon,{tag:"component",staticClass:"ab-icon",class:{ 'ab-icon_fit': _vm.containerSize }})
}
var staticRenderFns = []

export { render, staticRenderFns }